var React = require('react');

function DecorationBlur (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Rectangle"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"x1":"0%","y1":"48.6733838%","x2":"100%","y2":"48.6733838%","id":"linearGradient-1"},[React.createElement("stop",{"stopColor":"#241E17","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#FFFFFF","offset":"100%","key":1})])),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.394523963","key":3},React.createElement("g",{"transform":"translate(-355.000000, -39.000000)","fill":"url(#linearGradient-1)"},React.createElement("rect",{"id":"Rectangle","x":"355","y":"39","width":"20","height":"1000"})))]);
}

DecorationBlur.defaultProps = {"viewBox":"0 0 20 1000","version":"1.1"};

module.exports = DecorationBlur;

DecorationBlur.default = DecorationBlur;
